
import logoJac from '@assets/logos/jac-logo.png'
import logoJacSmall from '@assets/logos/jac-logo-small.png'
import { ClientConfigInfo, FILTER_TYPES, METADADATA_LOAD, SurveyResponsesTab } from './configCommons'
import { DASHBOARDS, DASHBOARDS_CONFIGS } from '../dashboard/dashboardCommons'
import { commonFilterCriticalMomentDefault, commonFilterCriticalMoments } from '../dashboard/dashHelper'
import { omoikaneJac } from '../omoikane/omoikaneJac'
import jacHelpDefinition from '../help/jacHelp'

export const jacConfigs: ClientConfigInfo = {
    vocBackendUrl: 'https://jac-backend-voc.limetropy.com/api/',
    //vocBackendUrl: 'http://localhost:9000/api/',
    lcmBackendUrl: 'https://jac-backend-core.limetropy.com/api/ui/',
    publicUrl: '/voc',
    logoSmall: logoJacSmall,
    logo: logoJac,
    filtersFromDateSubstract: 2,
    filtersToDateSubstract: 0,
    decimals: undefined,
    filters: [
        FILTER_TYPES.DATES,
        FILTER_TYPES.CRITICAL_MOMENTS,
        FILTER_TYPES.GEOS,
        FILTER_TYPES.LOGICALS,
        FILTER_TYPES.DYNAMIC
    ],
    supportsInternationalization: true,
    msExcelReportExt: 'xlsx',
    menuDashboards: [DASHBOARDS.DEFAULT],
    sentimentCommentsIndicatorName: 'SENTIMENT_COMMENTS',
    // Filters
    dateFromParamName: 'customerServiceTimeFrom',
    dateToParamName: 'customerServiceTimeTo',
    geosRootId: 14601,
    logicalsRootId: 29,
    criticalMomentsRootId: 29,
    criticalMomentFilterType: 'tree',
    actionPlans: {
        geoLeafLevel: 'SUCURSAL',
        useWorstTags: true
    },
    omoikane: omoikaneJac,
    // Dashboards
    useBackDashboards: false,
    staticDashboards: {},
    dynamicDashboards: [/*12901, 11509, 11510, 11512, 11513*/],
    //dynamicDashboards: [],
    useDefaultCriticalMoment: true,
    useDashboardDynamicPosition: true,
    metadata: [
        METADADATA_LOAD.CRITICAL_MOMENTS,
        METADADATA_LOAD.GEOS,
        METADADATA_LOAD.LOGICALS,
        METADADATA_LOAD.DYNAMIC_REPORT_FIELDS,
        //METADADATA_LOAD.WORKFLOWS
    ],
    dashboards: {
        ...DASHBOARDS_CONFIGS.jac,
        default: DASHBOARDS_CONFIGS.jac[DASHBOARDS.DEFAULT]
    },
    surveyResponses: {
        url: 'survey-responses',
        type: 'post',
        tableColumns: undefined,
        tabs: [SurveyResponsesTab.ANSWERED, SurveyResponsesTab.NOT_ANSWERED],
        surveyDetailFields: [
            {
                position: 1,
                label: 'VIN',
                getValue: data => {
                    //console.log('custom field!!!!!!!!!!')
                    //console.log(data)
                    return data?.customerServiceCode ?? '-'
                }
            }
        ],
    },
    alerts: {
        alertDetailActions: {
            reopen: true
        },
        alertDetailFields: [
            {
                position: 1,
                label: 'VIN',
                getValue: data => {
                    //console.log('custom field!!!!!!!!!!')
                    //console.log(data)
                    return data?.customerServiceCode ?? '-'
                }
            }
        ],
        alertFilterFields:{
            enabled: true,
            alertId: true,
            surveyResponseId: true,
            customerServiceCode: true
        }
    },
    userPhoneNumber: true,
    help: jacHelpDefinition
}
